/*
 * Public API Surface of Survery Shared
 */

export { SurveySharedModule } from './lib/shared.module';
